import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule, FormGroupDirective } from '@angular/forms';
import { AlertService, AuthService } from '@wm-libs/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { map } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Util } from '@wm-libs/core';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule, TranslateModule],
})
export class ChangePasswordComponent {
  changePasswordForm: FormGroup;
  hidePassword1 = true;
  hidePassword2 = true;
  hidePassword3 = true;

  isTablet$ = this.breakpointObserver.observe([Breakpoints.Small]).pipe(map((result) => result.matches));

  isMobile$ = this.breakpointObserver.observe([Breakpoints.XSmall]).pipe(map((result) => result.matches));

  isMedium$ = this.breakpointObserver.observe([Breakpoints.Medium]).pipe(map((result) => result.matches));

  constructor(
    private breakpointObserver: BreakpointObserver,
    private authService: AuthService,
    private fb: FormBuilder,
    private alertService: AlertService,
    private translateService: TranslateService
  ) {
    this.changePasswordForm = this.fb.group(
      {
        currentPassword: ['', [Validators.required]],
        password: ['', [Validators.required, Util.passwordValidator()]],
        confirmPassword: ['', Validators.required],
      },
      { validators: Util.passwordsMatch }
    );
  }

  changePassword(formDirective: FormGroupDirective) {
    if (this.changePasswordForm.valid) {
      const { currentPassword, password } = this.changePasswordForm.value;

      if (currentPassword === password) {
        return this.alertService.showAlert(this.translateService.instant('PASWORD.CHANGE.DIFFERENT'), 'error');
      }

      this.authService.changePassword(currentPassword, password).subscribe(() => {
        this.alertService.showAlert(this.translateService.instant('PASWORD.CHANGE.SUCCESS'), 'success');

        this.changePasswordForm.reset();
        formDirective.resetForm();
      });
    } else {
      this.alertService.showAlert(this.translateService.instant('FORMS.NOT_VALID'), 'error');
    }
  }
}
